module.exports = __webpack_public_path__ + "img/cattle-918644_1280.4a400840.jpg";